<span class="notification__blue-text">&#64; {{ 'mentioned' | ppTranslate }}</span>
{{ 'you_in_a_new_point' | ppTranslate }}
